// extracted by mini-css-extract-plugin
module.exports = {"container":"ReadMoreCollapsible_container__Gd0c_","body":"ReadMoreCollapsible_body__nK2hB","title":"ReadMoreCollapsible_title__afl70"};